import React, { useState } from 'react'
import styles from './styles.css'
import { Button } from '@deal/components'
import ArrowUp from './arrow-up.svg'
import ArrowDown from './arrow-down.svg'
import truncate from 'lodash/truncate'

interface Props {
  descriptionText: string | null
  className?: string
  header?: React.ReactNode
}

const Description: React.SFC<Props> = ({ descriptionText }) => {
  const [isReadMoreExpanded, setReadMoreExpanded] = useState(false)

  if (!descriptionText) {
    return null
  }

  let description = descriptionText
  const shouldTrimDescription = descriptionText.length > 400

  if (shouldTrimDescription && !isReadMoreExpanded) {
    description = truncate(description, {
      length: 400,
      separator: ' '
    })
  }

  return (
    <div className={styles.container}>
      <p className={styles.description}>{description}</p>
      {shouldTrimDescription && (
        <Button
          variant="secondary"
          size="small"
          onClick={() =>
            isReadMoreExpanded ? setReadMoreExpanded(false) : setReadMoreExpanded(true)
          }
          className={styles.expand}
        >
          {isReadMoreExpanded ? (
            <>
              <ArrowUp /> Read less
            </>
          ) : (
            <>
              <ArrowDown /> Read more
            </>
          )}
        </Button>
      )}
    </div>
  )
}

export default Description
